import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListScoreContainer = styled.div<React.CSSProperties>`
  margin-top: ${Screen.widthRatio * 12}px;
`;

export default ChannelListScoreContainer;
